export const EMPLOYER_ROLES = ["employer", "company", "agency", "admin"];
export const isEmployer = (r) => EMPLOYER_ROLES.includes(r);
export const isAgency = (r) => r === "agency" || r === "admin";
export const isCompany = (r) => r === "company" || r === "employer";
export const homeFor = (r) => (isEmployer(r) ? "/dashboard" : "/radar");
